/* Maison KN — storefront behaviour.

   Rewritten for the theme. The prototype's hash router, its DOM-cloning image
   reuse and its embedded-card search are all gone: Shopify gives us real URLs,
   a CDN and a search endpoint. What carries over is the behaviour that was
   tuned by hand — the docking section nav, the hero settle and caption
   stagger, the drawers, and the collection facets. */
(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  /* ---------- date and time in the top bar ---------- */
  (function () {
    var d = $("#moonDate"), t = $("#moonTime");
    if (!d) return;
    var MONTHS = ["January", "February", "March", "April", "May", "June", "July",
                  "August", "September", "October", "November", "December"];
    function tick() {
      var n = new Date();
      d.textContent = n.getDate() + " " + MONTHS[n.getMonth()] + " " + n.getFullYear();
      if (t) t.textContent = String(n.getHours()).padStart(2, "0") + ":" +
                             String(n.getMinutes()).padStart(2, "0");
    }
    tick();
    setInterval(tick, 15000);
  })();

  /* ---------- hero carousel ---------- */
  (function () {
    var hero = $(".hero");
    if (!hero) return;
    var slides = $$(".slide", hero), dots = $$(".dot", hero), at = 0, timer;
    if (slides.length < 2) return;
    function go(i) {
      at = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("is-on", k === at); });
      dots.forEach(function (d, k) { d.classList.toggle("is-on", k === at); });
    }
    function play() { clearInterval(timer); timer = setInterval(function () { go(at + 1); }, 6000); }
    dots.forEach(function (d) {
      d.addEventListener("click", function () { go(+d.getAttribute("data-to")); play(); });
    });
    play();
  })();

  /* ---------- section nav: rides in the page, then docks ----------
     A fixed element has no useful offsetTop, so once docked the test measures
     the spacer that took its place in flow. */
  (function () {
    var nav = $("#secnav"), spacer = $("#secnavSpacer");
    if (!nav || !spacer) return;
    var barH = function () {
      return parseInt(getComputedStyle(document.documentElement)
        .getPropertyValue("--bar"), 10) || 64;
    };
    function syncDock() {
      var docked = nav.classList.contains("is-docked");
      var anchor = docked ? spacer.offsetTop : nav.offsetTop;
      var should = window.scrollY + barH() >= anchor;
      if (should === docked) return;
      if (should) {
        spacer.style.height = nav.offsetHeight + "px";
        spacer.style.display = "block";
        nav.classList.add("is-docked");
      } else {
        nav.classList.remove("is-docked");
        spacer.style.display = "none";
      }
    }
    function syncActive() {
      // Off the home page there are no bands to spy on and Liquid has already
      // marked the current page. Bail out rather than clearing it.
      var anchored = $$("a[data-sec]", nav).filter(function (a) {
        var id = a.getAttribute("data-sec");
        return id && document.getElementById(id);
      });
      if (!anchored.length) return;
      var line = window.scrollY + barH() + nav.offsetHeight + 12, current = null;
      $$("a[data-sec]", nav).forEach(function (a) {
        var el = document.getElementById(a.getAttribute("data-sec"));
        if (el && el.offsetTop <= line) current = a;
      });
      $$("a", nav).forEach(function (a) { a.classList.toggle("is-on", a === current); });
    }
    window.addEventListener("scroll", function () { syncDock(); syncActive(); }, { passive: true });
    syncDock(); syncActive();
  })();

  /* ---------- mega menu ----------
     Panes are rendered server-side, one per section, so this only switches
     which is visible. The brand filter that used to live here went with the
     search panel: the collection pages carry the real facets. */
  (function () {
    var menu = document.querySelector("#menu"), btn = document.querySelector("#menuBtn"),
        close = document.querySelector("#menuClose");
    if (!menu || !btn) return;
    var panes = $$(".menu-pane", menu), tabs = $$(".ms", menu);

    tabs.forEach(function (t) {
      t.addEventListener("click", function () {
        var key = t.getAttribute("data-view");
        tabs.forEach(function (x) { x.classList.toggle("is-on", x === t); });
        panes.forEach(function (p) { p.hidden = p.getAttribute("data-pane") !== key; });
      });
    });

    function open() {
      menu.hidden = false;
      document.body.style.overflow = "hidden";
      btn.setAttribute("aria-expanded", "true");
    }
    function shut() {
      menu.hidden = true;
      document.body.style.overflow = "";
      btn.setAttribute("aria-expanded", "false");
    }
    btn.addEventListener("click", function () { menu.hidden ? open() : shut(); });
    if (close) close.addEventListener("click", shut);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !menu.hidden) shut();
    });
  })();

  /* ---------- search sheet, over Shopify's predictive endpoint ---------- */
  (function () {
    var panel = $("#srch"), btn = $("#srchBtn"), close = $("#srchClose"),
        input = $("#srchInput"), pop = $("#srchPop"), grid = $("#srchGrid"),
        empty = $("#srchEmpty"), tabs = $("#srchTabs");
    if (!panel || !btn) return;
    var timer;

    function card(p) {
      var li = document.createElement("li");
      var a = document.createElement("a"); a.href = p.url;
      if (p.featured_image && p.featured_image.url) {
        var fig = document.createElement("figure");
        var im = document.createElement("img");
        im.src = p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, "_600x$1$2");
        im.alt = p.title; im.loading = "lazy";
        fig.appendChild(im); a.appendChild(fig);
      }
      if (p.vendor) {
        var k = document.createElement("p"); k.className = "mk"; k.textContent = p.vendor;
        a.appendChild(k);
      }
      var n = document.createElement("p"); n.className = "mn"; n.textContent = p.title;
      a.appendChild(n);
      li.appendChild(a);
      return li;
    }

    function run() {
      var q = (input.value || "").trim();
      if (!q) { grid.innerHTML = ""; empty.hidden = true; if (tabs) tabs.hidden = true; return; }
      fetch("/search/suggest.json?q=" + encodeURIComponent(q) +
            "&resources[type]=product&resources[limit]=12")
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          grid.innerHTML = "";
          items.forEach(function (p) { grid.appendChild(card(p)); });
          empty.textContent = "Nothing matches “" + q + "”.";
          empty.hidden = items.length > 0;
        })
        .catch(function () { empty.textContent = "Search is unavailable."; empty.hidden = false; });
    }

    function open() {
      panel.hidden = false; document.body.style.overflow = "hidden";
      document.body.classList.add("is-searching");
      input.focus();
    }
    function shut() {
      panel.hidden = true; document.body.style.overflow = "";
      document.body.classList.remove("is-searching");
    }
    btn.addEventListener("click", function () { panel.hidden ? open() : shut(); });
    if (close) close.addEventListener("click", shut);
    input.addEventListener("input", function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    if (pop) pop.addEventListener("click", function (e) {
      var b = e.target.closest("button");
      if (!b) return;
      input.value = b.textContent; input.focus(); run();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !panel.hidden) shut();
    });
  })();

  /* ---------- drawers on the product page ---------- */
  (function () {
    var opener = null;
    function shut(d) {
      d.classList.remove("is-open");
      document.body.style.overflow = "";
      if (opener) { opener.focus(); opener = null; }
    }
    $$("[data-drawer]").forEach(function (row) {
      row.addEventListener("click", function () {
        var d = document.getElementById(row.getAttribute("data-drawer"));
        if (!d) return;
        opener = row;
        d.classList.add("is-open");
        document.body.style.overflow = "hidden";
      });
    });
    $$(".drawer").forEach(function (d) {
      var x = $(".dr-x", d);
      if (x) x.addEventListener("click", function () { shut(d); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      $$(".drawer.is-open").forEach(shut);
    });
  })();


  /* ---------- photograph preview ----------
     Opens the whole set, however many that is: shots is read off the DOM, so
     the count, the wrap-around and the counter all follow the markup. The page
     carousel behind it still shows only the first ten. Deliberately no zoom:
     the images are served at 2000px and contained, so the whole frame is
     always on screen. */
  (function () {
    var pw = document.querySelector("#pw"), media = document.querySelector("#pdMedia");
    if (!pw || !media) return;
    var shots = $$(".pw-shot", pw), at = document.querySelector("#pwAt"),
        prev = $(".pw-prev", pw), next = $(".pw-next", pw), x = $(".pw-x", pw);
    var i = 0;

    // Pull a frame into cache without showing it. A display:none lazy image is
    // not fetched until it is displayed, so on a long set every press used to
    // land on a blank beat while that frame downloaded. Warming the two
    // neighbours hides it. Only ever one step either side, so paging the whole
    // set costs exactly what it did before -- just a frame earlier.
    function warm(n) {
      var s = shots[(n + shots.length) % shots.length];
      if (!s || s.dataset.warm) return;
      s.dataset.warm = "1";
      var pre = new Image();
      pre.src = s.getAttribute("src");
    }

    function show(n) {
      i = (n + shots.length) % shots.length;
      shots.forEach(function (s, k) { s.classList.toggle("is-on", k === i); });
      if (at) at.textContent = i + 1;
      warm(i + 1);
      warm(i - 1);
    }
    var opener = null;
    function openPw(from) {
      pw.hidden = false;
      document.body.style.overflow = "hidden";
      show(from || 0);
    }
    function shut() {
      pw.hidden = true;
      document.body.style.overflow = "";
      if (opener) { opener.focus(); opener = null; }
    }

    // Any photograph opens the preview, at that photograph. The camera in each
    // corner only advertises what the whole image already does.
    media.addEventListener("click", function (e) {
      var shot = e.target.closest(".pd-shot");
      if (!shot) return;
      if (!e.target.closest("img") && !e.target.closest(".pd-zoom")) return;
      opener = $(".pd-zoom", shot) || shot;
      openPw(parseInt(shot.getAttribute("data-i"), 10) || 0);
    });
    if (x) x.addEventListener("click", shut);
    if (prev) prev.addEventListener("click", function () { show(i - 1); });
    if (next) next.addEventListener("click", function () { show(i + 1); });
    document.addEventListener("keydown", function (e) {
      if (pw.hidden) return;
      if (e.key === "Escape") shut();
      else if (e.key === "ArrowLeft") show(i - 1);
      else if (e.key === "ArrowRight") show(i + 1);
    });
  })();

  /* ---------- collection: sort and facets over the rendered cards ---------- */
  (function () {
    var grid = $("#cvGrid");
    if (!grid) return;
    var countEl = $("#cvCount"), emptyEl = $("#cvEmpty"),
        sortBtn = $("#sortBtn"), sortMenu = $("#sortMenu"), sortLabel = $("#sortLabel"),
        filterBtn = $("#filterBtn"), drawer = $("#filterDrawer"),
        body = $("#filterBody"), clear = $("#clearFilters");
    var cards = $$("li.card", grid);
    cards.forEach(function (c, i) { c.dataset.order = i; });
    var chosen = {}, tallies = {};

    /* The grid holds the whole collection so sort and filter see all of it.
       Only the first STEP are shown; View more reveals another STEP. The cap
       counts in DOM order, so it follows whatever sort is in force. */
    var STEP = 24, cap = STEP;
    var moreWrap = $("#cvMore"), moreBtn = $("#cvMoreBtn");
    grid.classList.remove("is-precap");       // the inline pre-cap; JS owns it now

    var BANDS = [
      { label: "Under $2,500", test: function (p) { return p > 0 && p < 2500; } },
      { label: "$2,500 – $5,000", test: function (p) { return p >= 2500 && p < 5000; } },
      { label: "$5,000 – $7,500", test: function (p) { return p >= 5000 && p < 7500; } },
      { label: "$7,500 and above", test: function (p) { return p >= 7500; } }
    ];
    function band(p) {
      for (var i = 0; i < BANDS.length; i++) if (BANDS[i].test(p)) return BANDS[i].label;
      return "";
    }
    function val(c, key) {
      if (key === "priceBand") return band(parseFloat(c.dataset.price || "0"));
      return c.dataset[key] || "";
    }
    var FACETS = [
      { key: "brand", label: "Brand" },
      { key: "priceBand", label: "Price", order: BANDS.map(function (b) { return b.label; }) },
      { key: "sizeband", label: "Size" },   // whole mm; see snippets/size-band.liquid
      { key: "material", label: "Case material" }
    ];

    function matches(c) {
      for (var k in chosen) {
        if (chosen[k] && chosen[k].length && chosen[k].indexOf(val(c, k)) < 0) return false;
      }
      return true;
    }

    function render() {
      var shown = [];
      $$("li.card", grid).forEach(function (c) {     // re-read: sorting reorders
        if (matches(c)) shown.push(c); else c.hidden = true;
      });
      shown.forEach(function (c, i) { c.hidden = i >= cap; });
      if (countEl) countEl.textContent = shown.length + (shown.length === 1 ? " piece" : " pieces");
      if (emptyEl) emptyEl.hidden = shown.length > 0;
      var left = shown.length - cap;
      if (moreWrap) moreWrap.hidden = left <= 0;
      grid.classList.toggle("is-capped", left > 0);
    }

    if (moreBtn) moreBtn.addEventListener("click", function () {
      cap += STEP;
      render();
    });

    function sortBy(mode) {
      var out = cards.slice();
      if (mode === "price-desc") out.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      else if (mode === "price-asc") out.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      else if (mode === "brand") out.sort(function (a, b) {
        return (a.dataset.brand || "").localeCompare(b.dataset.brand || "") ||
               (a.dataset.name || "").localeCompare(b.dataset.name || "");
      });
      else out.sort(function (a, b) { return a.dataset.order - b.dataset.order; });
      out.forEach(function (c) { grid.appendChild(c); });
      render();        // the cap counts in DOM order, so it must follow the sort
    }

    function buildFacets() {
      if (!body) return;
      body.innerHTML = ""; tallies = {};
      FACETS.forEach(function (f) {
        var vals = [];
        cards.forEach(function (c) {
          var v = val(c, f.key);
          if (v && vals.indexOf(v) < 0) vals.push(v);
        });
        if (vals.length < 2) return;                 // could not filter anything
        if (f.order) vals.sort(function (a, b) { return f.order.indexOf(a) - f.order.indexOf(b); });
        else vals.sort(function (a, b) { return a.localeCompare(b, undefined, { numeric: true }); });

        var d = document.createElement("details");
        d.className = "filter-group";
        var sum = document.createElement("summary");
        sum.textContent = f.label;
        var tally = document.createElement("span");
        tally.textContent = "Any";
        sum.appendChild(tally); d.appendChild(sum);
        tallies[f.key] = tally;

        var wrap = document.createElement("div");
        wrap.className = "filter-opts";
        if (vals.length > 9) wrap.classList.add("is-scroll");
        vals.forEach(function (v) {
          var row = document.createElement("label");
          row.className = "filter-check";
          var box = document.createElement("input");
          box.type = "checkbox";
          box.addEventListener("change", function () {
            chosen[f.key] = chosen[f.key] || [];
            var at = chosen[f.key].indexOf(v);
            if (at > -1) chosen[f.key].splice(at, 1); else chosen[f.key].push(v);
            var n = chosen[f.key].length;
            tally.textContent = n ? n + " selected" : "Any";
            cap = STEP;                               // a new result set starts short
            render();                                 // facets stay put
          });
          var txt = document.createElement("span");
          txt.textContent = v;
          row.appendChild(box); row.appendChild(txt);
          wrap.appendChild(row);
        });
        d.appendChild(wrap); body.appendChild(d);
      });
    }

    if (filterBtn && drawer) {
      filterBtn.addEventListener("click", function () {
        drawer.classList.add("is-open"); document.body.style.overflow = "hidden";
      });
    }
    if (clear) clear.addEventListener("click", function () {
      chosen = {}; cap = STEP; buildFacets(); render();
    });
    if (sortBtn && sortMenu) {
      sortBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        var open = !sortMenu.hidden;
        sortMenu.hidden = open;
        sortBtn.setAttribute("aria-expanded", String(!open));
      });
      sortMenu.addEventListener("click", function (e) {
        var b = e.target.closest("button[data-sort]");
        if (!b) return;
        sortBy(b.getAttribute("data-sort"));
        if (sortLabel) sortLabel.textContent = b.textContent;
        sortMenu.hidden = true;
      });
      document.addEventListener("click", function () { sortMenu.hidden = true; });
    }

    buildFacets();
    render();
  })();

  /* ---------- product carousel, phone only ----------
     The swiping is CSS scroll-snap and needs none of this. What follows adds
     the arrows, the counter and the progress bar, which ship hidden in the
     markup and are revealed here — so if this never runs, the carousel still
     swipes rather than showing controls that do nothing. */
  (function () {
    var media = $("#pdMedia");
    if (!media) return;
    var shots = $$(".pd-shot", media);
    if (shots.length < 2) return;

    var prev = $("#pdPrev"), next = $("#pdNext"),
        count = $("#pdCount"), at = $("#pdAt"),
        rail = $("#pdRail"), bar = $("#pdBar");
    var phone = window.matchMedia("(max-width: 760px)");

    function index() {
      // round rather than floor: a half-swipe that settles back should not
      // read as the next frame
      return Math.round(media.scrollLeft / media.clientWidth);
    }
    function paint() {
      var i = Math.min(Math.max(index(), 0), shots.length - 1);
      if (at) at.textContent = i + 1;
      if (bar) bar.style.transform = "translateX(" + (i * 100) + "%)";
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= shots.length - 1;
    }
    function go(step) {
      media.scrollBy({ left: step * media.clientWidth, behavior: "smooth" });
    }

    function sync() {
      var on = phone.matches;
      [prev, next, count, rail].forEach(function (el) { if (el) el.hidden = !on; });
      if (on) paint();
    }

    if (prev) prev.addEventListener("click", function () { go(-1); });
    if (next) next.addEventListener("click", function () { go(1); });
    media.addEventListener("scroll", function () {
      if (phone.matches) paint();
    }, { passive: true });

    if (phone.addEventListener) phone.addEventListener("change", sync);
    else if (phone.addListener) phone.addListener(sync);
    window.addEventListener("resize", sync);
    sync();
  })();

  /* ---------- back link: the previous screen ----------
     The href is always a real destination, for anyone who arrived without any
     history — a bookmark, a new tab, a link in a message. When there IS a
     previous page on this site, go there instead: the reader returns to the
     listing they left, at the scroll position they left it, which no href can
     reproduce. A link whose section names its own collection opts out of this
     and has no data-back. */
  (function () {
    $$("a.pv-back[data-back]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var ref = document.referrer;
        // same site, and not this very page reloaded
        if (!ref || ref.indexOf(location.origin) !== 0 || ref === location.href) return;
        if (history.length < 2) return;
        e.preventDefault();
        history.back();
      });
    });
  })();
})();
